export default __webpack_public_path__ + "static/media/arrow_down.82f38203.svg";